import { StudentInternShipKeyDetails } from "./student-internship-key-details-model";

export class MentorFeedback{
    subtitle ='Mentor Feedback';
    keyDetails:StudentInternShipKeyDetails[] = []
}